module.exports = __webpack_public_path__ + "nc_static/media/summary-table.svg.c7577be5.icon";